import { FunctionComponent } from "react";
import NodesList, { NodesListProps } from "./nodes-list";

const ModelPartsList: FunctionComponent<NodesListProps> = (props) => {
  return (
    <div className="p-6 border-b">
      <div className="font-bold mb-6 text-lg">Model parts</div>
      <NodesList {...props} />
    </div>
  );
};

export default ModelPartsList;
